customerID = window.hulkappsWishlist.customerID;
customerName = window.hulkappsWishlist.customerName;
hulkShopDomain = window.hulkappsWishlist.domain;
customerStatus = 'Customer';
hulkBody = document.body;
const iconWishlistSharePopupCross = document.querySelector('.whishlist-share-popup-bottom .icon-wishlist-cross');
const wishlistSharePopup = document.querySelector('.wishlist-share-popup');
const wishlistItems = document.querySelector('.wishlist-items');

function _addModalFocus(modal) {
  var focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal

  var focusableContent = modal.querySelectorAll(focusableElements);
  var lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

  hulkBody.style.overflow = 'hidden';
  document.addEventListener('keydown', function (e) {
    var isTabPressed = e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus(); // add focus for the last focusable element

        e.preventDefault();
      }
    } else {
      // if tab key is pressed
      if (document.activeElement === lastFocusableElement) {
        // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus(); // add focus for the first focusable element

        e.preventDefault();
      }
    }
  });
  firstFocusableElement.focus();
}

function _emailValidation(customerEmail) {
  var reg = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/gim;

  if (reg.test(customerEmail) == false) {
    return false;
  }

  return true;
}

function _getUserWishlist() {
  if (customerID != null && customerID != undefined && customerID != '') {
    var ShopURL =
      window.hulkappsWishlist.baseURL +
      '/wishlist/lists?customer_id=' +
      customerID +
      '&shop=' +
      hulkShopDomain +
      '&search=' +
      searchWishlist;

    _XMLHttpRequest('GET', ShopURL, '', hulkShopDomain, customerID, function (status, response) {
      var finalResponse = JSON.parse(response);

      if (status == 200) {
        finalResponse.forEach(function (element) {
          var defaultElement = element.is_default;

          if (defaultElement == true) {
            DefaultWishlistID = element.id;
            return;
          }
        });

        if (SelectedWishlistID == '') {
          SelectedWishlistID = DefaultWishlistID;
        }

        sessionStorage.setItem('wishlistsData', JSON.stringify(response));

        _updateWishlistHTML(finalResponse);
      } else {
        var msg = 'Something went wrong. Please try again later!';

        if (finalResponse.message) {
          msg = finalResponse.message;
        }

        _messageUpdate(msg);
      }
    });
  }
}

function _shareWishlist() {
  document.addEventListener('click', function (event) {
    if (event.target && event.target.hasAttribute('data-HulkShareWishList') == true) {
      event.preventDefault();
      var currentTarget = event.target;
      var uniqIdentifier;

      if (currentTarget.closest('[data-userhulkwishlist]')) {
        uniqIdentifier = currentTarget.closest('[data-userhulkwishlist]').getAttribute('data-uniqId');
      } else {
        uniqIdentifier = currentTarget.getAttribute('data-uniqId');
      }

      if (uniqIdentifier == null || uniqIdentifier == undefined) {
        return;
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol;
      var shareLink = protocol + '//' + hostName + proxyURL + '/share?listID=' + uniqIdentifier;
      var facebookShare = 'https://www.facebook.com/sharer/sharer.php?u=' + shareLink;
      var TwitterShare = 'https://twitter.com/share?text=Checkout My wishlist &amp;url=' + shareLink;
      var pinterestShare =
        'https://pinterest.com/pin/create/button/?url=' + shareLink + '&amp;description=Checkout My Wishlist'; // let tumblurShare = 'mailto:?subject=I wanted you to check out this wishlist at '+shareLink;

      /*For custom shared email*/

      var enableEmail =
        typeof WishlistSettings.style.share_email !== 'undefined' ? WishlistSettings.style.share_email : true;

      if (enableEmail) {
        var body =
          (WishlistSettings.language.shared_email
            ? WishlistSettings.language.shared_email.body
            : 'Hey there! Check out my wishlist:') +
          '\n\n' +
          shareLink;
        var subject = WishlistSettings.language.shared_email
          ? WishlistSettings.language.shared_email.subject
          : '{shopper_name} shared their wishlist!';
        subject = subject.replace('{shopper_name}', customerName);
        document.querySelector('[data-HulkEmailForm] [name="subject"]').value = subject;
        document.querySelector('[data-HulkEmailForm] [name="body"]').value = body;

        if (WishlistSettings.language.shared_email) {
          document.querySelector('#from_name_label').innerHTML = WishlistSettings.language.shared_email.name;
          document.querySelector('#email_label').innerHTML = WishlistSettings.language.shared_email.email;
          document.querySelector('#subject_label').innerHTML = WishlistSettings.language.shared_email.subject_label;
          document.querySelector('#email_body_label').innerHTML = WishlistSettings.language.shared_email.body_label;
        } else {
          document.querySelector('#from_name_label').innerHTML = 'Sender Name*';
          document.querySelector('#email_label').innerHTML = 'Recipients Email*';
          document.querySelector('#subject_label').innerHTML = 'subject';
          document.querySelector('#email_body_label').innerHTML = 'Message';
        }
      }

      document.querySelectorAll('[data-HulkappsShare]')[0].classList.add('open');
      wishlistItems.classList.add('hidden');


      _addModalFocus(document.querySelector('[data-HulkappsShare]'));

      document.querySelectorAll('[data-shareURL]')[0].value = shareLink;

      if (WishlistSettings.style.facebook) {
        document.querySelectorAll('[data-shareFacebook]')[0].setAttribute('href', facebookShare);
      }

      if (WishlistSettings.style.twitter) {
        document.querySelectorAll('[data-shareTwitter]')[0].setAttribute('href', TwitterShare);
      }

      if (WishlistSettings.style.pinterest) {
        document.querySelectorAll('[data-sharePintrest]')[0].setAttribute('href', pinterestShare);
      }

      var copyLinkEle = document.querySelector('[data-copyshareURLButton] img');

      if (copyLinkEle) {
        copyLinkEle.setAttribute(
          'src',
          'https://hulkapps-wishlist.nyc3.digitaloceanspaces.com/assets/images/share_link.svg'
        );
      }
    }
  });

  if (
    document.querySelectorAll('[data-copyshareURLButton]')[0] != null ||
    document.querySelectorAll('[data-saveNewMyWishlist]')[0] != undefined
  ) {
    document.querySelectorAll('[data-copyshareURLButton]')[0].onclick = function (event) {
      event.preventDefault();
      var copyText = document.getElementById('shareURL');
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      /*For mobile devices*/

      document.execCommand('copy');
      alert('Link has been copied!');
    };
  }

  if (document.querySelector('[data-HulkSendEmailButton]')) {
    document.querySelector('[data-HulkSendEmailButton]').addEventListener('click', function (event) {
      event.preventDefault();
      var email = document.querySelector('[data-HulkEmailForm] [name="email"]').value;
      var name = document.querySelector('[data-HulkEmailForm] [name="name"]').value;
      var subject = document.querySelector('[data-HulkEmailForm] [name="subject"]').value;
      var body = document.querySelector('[data-HulkEmailForm] [name="body"]').value;
      if (email != undefined && email != null) email = email.trim();

      if (name.length <= 0) {
        alert('Enter name!');
      } else if (email && email.length <= 0) {
        alert('Enter Email!');
      } else if (_emailValidation(email) == false) {
        alert('Enter Valid Email!');
      } else if (subject.length <= 0) {
        alert('Enter Subject!');
      } else if (body.length <= 0) {
        alert('Enter body!');
      } else {
        var data = {
          name: name,
          email: email,
          body: body,
          subject: subject,
        };

        var _request2 = new XMLHttpRequest();

        _request2.open('POST', window.hulkappsWishlist.baseURL + '/wishlist/send_custom_mail', true);

        _request2.setRequestHeader('Content-type', 'application/json');

        _request2.send(JSON.stringify(data));

        _request2.onload = function () {
          if (_request2.status == 200) {
            _getUserWishlist();

            document.querySelector('[data-HulkappsShare]').classList.remove('open');
            wishlistItems.classList.remove('hidden');
            hulkBody.style.overflow = '';
            var msg = 'Email sent successfully!';

            _messageUpdate(msg);
          } else {
            var response = JSON.parse(this.response);
            var _msg7 = 'Something went wrong. Please try again later!';

            if (response.message) {
              _msg7 = response.message;
            }

            _messageUpdate(_msg7);
          }
        };
      }
    });
  }
}

_XMLHttpRequest: function _XMLHttpRequest(type, URL, data) {
  var domain = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var customerID = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var callback = arguments.length > 5 ? arguments[5] : undefined;
  var script = document.createElement('script');
  script.src = 'https://cdnjs.cloudflare.com/ajax/libs/crypto-js/4.0.0/crypto-js.min.js';
  var newDataRequest = new XMLHttpRequest();
  newDataRequest.open(type, URL, true);
  newDataRequest.setRequestHeader('Accept', 'application/json');
  newDataRequest.setRequestHeader('Content-Type', 'application/json');

  script.onload = function () {
    newDataRequest.setRequestHeader('Encrypt-token', btoa(CryptoJS.SHA256(domain + customerID).toString()));

    if (type == 'GET') {
      newDataRequest.send();
    } else {
      newDataRequest.send(JSON.stringify(data));
    }
  };

  newDataRequest.onload = function () {
    callback(newDataRequest.status, this.response);
  };

  document.head.appendChild(script);
}

function _updateWishlistHTML(wishlistsData) {
  var sidebarHTML = '';
  var selectedWishlistFound = false;
  var triggerDefault = false;

  if (!wishlistsData) {
    return;
  }

  wishlistsData.forEach(function (wishlist) {
    var isCustomTitle = WishlistSettings.general.is_my_wishlist_custom_title
      ? WishlistSettings.general.is_my_wishlist_custom_title
      : false;
    var customTitle = WishlistSettings.general.my_wishlist_custom_title
      ? WishlistSettings.general.my_wishlist_custom_title
      : 'Your Wishlist';

    if (wishlist.is_default == true && WishlistSettings.general.has_multiple_wishlist == false) {
      if (isCustomTitle) {
        document.querySelectorAll('[data-wishlistTitle]')[0].innerHTML =
          wishlist.name.split(' ')[0] + ' ' + customTitle;

        if (hulkShopDomain === 'cc707a-8b.myshopify.com') {
          document.querySelectorAll('[data-wishlistTitle]')[0].innerHTML = customTitle;
        }
      } else {
        document.querySelectorAll('[data-wishlistTitle]')[0].innerHTML = wishlist.name;
      } //document.querySelectorAll('[data-wishlistTitle]')[0].innerHTML = wishlist.name;

      var wlAccountLink = WishlistSettings.general.wl_account_page_link
        ? WishlistSettings.general.wl_account_page_link
        : true;
      document.querySelectorAll('[data-forMultipleDisabled]')[0].style.display = 'inline-block';

      if (wlAccountLink) {
        document.querySelectorAll('[data-forMultipleDisabled]')[0].classList.add('enable-share_sbcrb');
      }

      var wlShareLink = WishlistSettings.style.share_button;

      if (document.querySelectorAll('[data-forMultipleDisabled]')[0].querySelector('[data-HulkShareWishList]')) {
        document
          .querySelectorAll('[data-forMultipleDisabled]')[0]
          .querySelector('[data-HulkShareWishList]')
          .setAttribute('data-uniqId', wishlist.unique_identifier);
      }

      if (
        (!WishlistSettings.general.wl_account_page_link && wlShareLink == 'show') ||
        (WishlistSettings.general.wl_account_page_link && wlShareLink == 'hide')
      ) {
        document.querySelectorAll('[data-forMultipleDisabled]')[0].classList.add('hide-before');
      }

      if (!WishlistSettings.general.wl_account_page_link && wlShareLink == 'hide') {
        document.querySelectorAll('[data-forMultipleDisabled]')[0].style.display = 'none';
      }

      if (document.querySelectorAll('[data-forMultipleDisabled]')[0].querySelector('[data-HulkSubscribetoList]')) {
        document
          .querySelectorAll('[data-forMultipleDisabled]')[0]
          .querySelector('[data-HulkSubscribetoList]')
          .setAttribute('data-id', wishlist.id);
        document
          .querySelectorAll('[data-forMultipleDisabled]')[0]
          .querySelector('[data-HulkSubscribetoList]')
          .setAttribute('data-email', wishlist.subscribed_email);

        if (wishlist.is_subscribed == true) {
          document
            .querySelectorAll('[data-forMultipleDisabled]')[0]
            .querySelector('[data-HulkSubscribetoList]').innerHTML = WishlistSettings.language.action_button.subscribed;
        }
      }
    }

    if (wishlist.id == parseInt(SelectedWishlistID)) {
      selectedWishlistFound = true;
      sidebarHTML +=
        '<li class="sidebar_item active" data-id="' +
        wishlist.id +
        '" data-email="' +
        wishlist.subscribed_email +
        '" data-subscribed="' +
        wishlist.subscribed_email +
        '" data-uniqId="' +
        wishlist.unique_identifier +
        '" data-userHulkwishlist>';
    } else {
      sidebarHTML +=
        '<li class="sidebar_item" data-id="' +
        wishlist.id +
        '" data-email="' +
        wishlist.subscribed_email +
        '" data-uniqId="' +
        wishlist.unique_identifier +
        '" data-userHulkwishlist>';
    }

    sidebarHTML += '<div class="sidebar_content" style="width: 100%">';
    sidebarHTML +=
      '<div style="position: relative; display: none;" id="wishlist_' +
      wishlist.id +
      '" data-updateWishlist="' +
      wishlist.id +
      '">';
    sidebarHTML +=
      '<input data-updateWishlistInput="" type="text" placeholder="Ex. Watch" value="' +
      wishlist.name +
      '" style="width: 100%;"><button class="close-new-wishlist-input" style="font-size: 10px; padding: 6px; color: #aaa; position: absolute; left: initial; right: 6%; top: 12%;"><span class="icon-wishlist-cross" data-closeupdatewishlistinput></span></button>';
    sidebarHTML +=
      '<button class="wishlist-btn hulkBtnStyle" data-updateexistingwishlist="' +
      wishlist.unique_identifier +
      '" data-uuid="' +
      wishlist.unique_identifier +
      '" data-id="' +
      wishlist.id +
      '" style="background-color: #5c6ac4; border: 1px solid #5c6ac4; color: white;">Save</button></div>';
    sidebarHTML += '<div class="hulk-wishlist" data-HulkwishlistView>';
    sidebarHTML +=
      '<a href="#" class="h6 Wishlist_cat_title ' +
      wishlist.id +
      '" data-HulkwishlistTitle>' +
      wishlist.name +
      ' <span>(' +
      wishlist.total_products +
      ')</span></a>';
    sidebarHTML +=
      '<a href="#" style="color: #000; position: relative; float: right;" data-hulkWishlistAction>...<div class="hulk-popover" style="display: none" data-hulkPopover><div class="popover-arrow"></div>';

    if (wishlist.is_default == false) {
      var _WishlistSettings$lan, _WishlistSettings$lan2;

      var renameWishlist =
        (_WishlistSettings$lan = WishlistSettings.language.title.rename_wishlist) !== null &&
          _WishlistSettings$lan !== void 0
          ? _WishlistSettings$lan
          : 'Rename';
      var deleteWishlist =
        (_WishlistSettings$lan2 = WishlistSettings.language.title.delete_wishlist) !== null &&
          _WishlistSettings$lan2 !== void 0
          ? _WishlistSettings$lan2
          : 'Delete';
      sidebarHTML += '<div class="popover-body" data-openRenameSection>' + renameWishlist + '</div>';
      sidebarHTML +=
        '<div class="popover-body delete-wishlist" data-confirmDeleteWishlist>' + deleteWishlist + '</div>';
    }

    if (WishlistSettings.style.share_button && WishlistSettings.style.share_button == 'show') {
      sidebarHTML +=
        '<div class="popover-body" data-HulkShareWishList>' + WishlistSettings.language.action_button.share + '</div>';
    }

    if (WishlistSettings.general.can_subscribe_wishlist == true && wishlist.is_subscribed == true) {
      sidebarHTML +=
        '<div class="popover-body" data-HulkSubscribetoList>' +
        WishlistSettings.language.action_button.subscribed +
        '</div>';
    } else if (WishlistSettings.general.can_subscribe_wishlist == true) {
      sidebarHTML +=
        '<div class="popover-body" data-HulkSubscribetoList>' +
        WishlistSettings.language.action_button.subscribe +
        '</div>';
    }

    sidebarHTML += '</div></a></div>';
    sidebarHTML += '</div>';
    sidebarHTML += '</li>';
  });

  if (
    WishlistSettings.style.share_button === 'hide' &&
    !WishlistSettings.general.can_subscribe_wishlist &&
    WishlistSettings.general.has_multiple_wishlist
  ) {
    setTimeout(function () {
      document.querySelectorAll('li.sidebar_item.active a[data-hulkWishlistAction]')[0].style.display = 'none';
    }, 2000);
  }

  var hulkWishlistListing = document.querySelectorAll('[data-HulkWishlistListing]')[0];

  if (SelectedWishlistID == '') {
    SelectedWishlistID = DefaultWishlistID;
  }

  if (typeof hulkWishlistListing != 'undefined' && hulkWishlistListing != null) {
    document.querySelectorAll('[data-HulkWishlistListing]')[0].innerHTML = sidebarHTML;
  }
}

_messageUpdate: function _messageUpdate(msg) {
  var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var image = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var is_latest_notification = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var allowNotifications =
    typeof WishlistSettings.general.wishlist_notifications === 'undefined'
      ? true
      : WishlistSettings.general.wishlist_notifications;
  var currentFormMsg = document.querySelectorAll('.wishlistError')[0];
  var popupDelay =
    typeof WishlistSettings.general.popup_delay !== 'undefined' ? WishlistSettings.general.popup_delay : '5';

  if (currentFormMsg != null && currentFormMsg != undefined && allowNotifications) {
    if (is_latest_notification) {
      var message = msg.replace('{Product}', '<b>'.concat(title, '</b>'));
      var template = '<div class="hulk_notification_container">';
      template +=
        '<div class="notification_close" data-closeNotification onclick="document.querySelectorAll(\'.wishlistError\')[0].classList.remove(\'hulkActive\')"><span class="icon-wishlist-cross" data-closeNotification></span></div>';
      template += '<img src="'.concat(image, '" alt="wishlist product"/>');
      template += '<div class="message_container"><div class="notification_details">'.concat(message, '</div></div>');
      template += '</div>';
      currentFormMsg.innerHTML = template;
    } else {
      var _message = msg;
      var _template = '<div class="hulk_notification_container">';
      _template +=
        '<div class="notification_close" data-closeNotification onclick="document.querySelectorAll(\'.wishlistError\')[0].classList.remove(\'hulkActive\')"><span class="icon-wishlist-cross" data-closeNotification></span></div>';
      _template += '<div class="message_container"><div class="notification_details">'.concat(_message, '</div></div>');
      _template += '</div>';
      currentFormMsg.innerHTML = _template; // currentFormMsg.innerHTML = msg;
    }

    currentFormMsg.classList.add('hulkActive');
    setTimeout(function () {
      currentFormMsg.classList.remove('hulkActive');
    }, parseInt(popupDelay) * 1000);
  }
}

_shareWishlist();

if (iconWishlistSharePopupCross) {
  iconWishlistSharePopupCross.addEventListener('click', function () {
    wishlistSharePopup.classList.remove('open');
    hulkBody.style.overflow = '';
    wishlistItems.classList.remove('hidden');
  });
}